module.exports = __webpack_public_path__ + "img/urbi-thumb.4e5e89ff.jpg";